// Header names for forwarding geolocation to the API. Sole definition: the
// server middleware reads Cloudflare headers, not these.
export const GEO_HEADERS = {
	CITY: "x-geo-city",
	COUNTRY: "x-geo-country",
	REGION: "x-geo-region",
	LATITUDE: "x-geo-latitude",
	LONGITUDE: "x-geo-longitude",
	// Set when the location being sent is our placeholder rather than a detected
	// one, so the gateway doesn't report it as real geo.
	IS_FALLBACK: "x-geo-is-fallback"
};

// Builds the x-geo-* request headers from a user geolocation object. Only
// present fields are included — absent/empty values are omitted so we never
// send a literal "undefined" (or empty) header value to the gateway.
export default function buildGeoHeaders(geolocation) {
	if (!geolocation) return {};
	const fields = [
		[GEO_HEADERS.CITY, geolocation.city],
		[GEO_HEADERS.COUNTRY, geolocation.country],
		[GEO_HEADERS.REGION, geolocation.region],
		[GEO_HEADERS.LATITUDE, geolocation.latitude],
		[GEO_HEADERS.LONGITUDE, geolocation.longitude]
	];
	const headers = fields.reduce((acc, [name, value]) => {
		if (value !== undefined && value !== null && value !== "") {
			acc[name] = String(value);
		}
		return acc;
	}, {});

	// Sent only when true: an absent header means no claim was made, which the
	// gateway reads as a real location.
	if (geolocation.isFallback) {
		headers[GEO_HEADERS.IS_FALLBACK] = "1";
	}

	return headers;
}
